import {AfterViewInit, Component, OnInit, signal} from '@angular/core';
import {authConfigAbove, authConfigCastlabs} from './authConfig';
import {OAuthService} from 'angular-oauth2-oidc';
import {inject} from '@angular/core';
import {TokenRefreshService} from './services/token-refresh.service';
import {Router, RouterOutlet} from '@angular/router';
import {PortalIdpService} from './services/portal-idp.service';
import {cleanLocalStorage} from './components/utils';
import {safeReturnPath} from './services/return-path';
import {LoginPageComponent} from './components/login-page.component';
import {ContextService} from './services/context.service';
import {environment} from '../environments/environment';
import {clThemeSetup} from '@castlabs/ui';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [RouterOutlet, LoginPageComponent],
})
export class AppComponent implements OnInit, AfterViewInit {
  loggedIn = signal(false);
  loggingIn = signal(true);

  constructor(
    public oAuthService: OAuthService,
    router: Router,
    private portalIdp: PortalIdpService,
    private contextService: ContextService,
    /* Technically not needed here but it's loaded early enough  */
  ) {
    const isAbove = window.location.hostname.startsWith('above');
    this.portalIdp.setIdpName(isAbove ? 'above' : 'Castlabs');

    if (environment.localDev && !environment.env_name) {
      // No env chosen yet — show login page with env picker, skip OAuth.
      this.loggingIn.set(false);
      return;
    }

    oAuthService.setStorage(localStorage)
    oAuthService.configure(isAbove ? authConfigAbove : authConfigCastlabs);
    // TokenRefreshService.start() loads the discovery document before anything can refresh, and turns any
    // failure into the login page or a new sign-in -- never a blank page (VTK-3596).
    inject(TokenRefreshService).start().then(loggedIn => {
      this.loggedIn.set(loggedIn)
      this.loggingIn.set(false)
      if (loggedIn) {
        // The OAuth state comes back through the IdP: only a route of this app is followed.
        const returnTo = safeReturnPath(this.oAuthService.state);
        if (returnTo) {
          console.log('Navigate back to URL before login');
          router.navigateByUrl(returnTo, { replaceUrl: true });
        }
      }
    });
    oAuthService.events.subscribe(() => {
      this.loggedIn.set(this.oAuthService.hasValidAccessToken())
    })
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // The #cl-mode-dark checkbox exists now, for every page: logged in, login page and /reports alike.
    // castlabs-ui reads the theme from its cl_ui_settings and keeps it in sync with the checkbox.
    clThemeSetup();
  }

  cleanLocalStorage() {
    cleanLocalStorage();
  }
}
